import { MouseEventHandler } from "react"
import { Box, Button, Flex } from "@shared/primitive-components"
import * as styles from "./styles/actionButtonStyles"

interface Props {
  onCancel?: MouseEventHandler<HTMLButtonElement>
  onBack?: MouseEventHandler<HTMLButtonElement>
  onNext?: MouseEventHandler<HTMLButtonElement>
  nextDisabled?: boolean
  nextText?: string
  dataTestIds?: {
    cancel?: string
    back?: string
    next?: string
  }
}

export const ActionButtons = ({ onCancel, onBack, onNext, nextDisabled, nextText, dataTestIds }: Props) => (
  <Flex width="100%" justifyContent="space-between" css={styles.marginTop}>
    <Box>
      {onCancel && (
        <Button variant="outline" type="button" onClick={onCancel} data-testid={dataTestIds?.cancel}>
          Cancel
        </Button>
      )}
    </Box>
    <Box>
      {onBack && (
        <Button
          variant="outline"
          type="button"
          onClick={onBack}
          css={styles.marginRight}
          data-testid={dataTestIds?.back}
        >
          Back
        </Button>
      )}
      <Button disabled={nextDisabled} onClick={onNext} data-testid={dataTestIds?.next}>
        {nextText || `Next`}
      </Button>
    </Box>
  </Flex>
)

ActionButtons.defaultProps = {
  onCancel: undefined,
  onBack: undefined,
  onNext: undefined,
  nextDisabled: undefined,
  nextText: undefined,
  dataTestIds: undefined,
}
